import { render, staticRenderFns } from "./index_activity.vue?vue&type=template&id=055a8e14&scoped=true"
import script from "./index_activity.vue?vue&type=script&lang=js"
export * from "./index_activity.vue?vue&type=script&lang=js"
import style0 from "./index_activity.vue?vue&type=style&index=0&id=055a8e14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a8e14",
  null
  
)

export default component.exports